import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  RiaLiterature,
  FundLiterature,
  FormsAndApplications,
  IntervalFundsContainer,
  InvestorLogin,
  VariableFunds,
  CombineMorningstarfundsContainer,
  MutualFundsContainer,
  ExchangeTradedFunds,
  ModelPortfoliosContainer,
  AllProductTypesContainer,
  ClosedEndFundsContainer,
  IndexDescriptionGlossaryContainer,
  FutureScholarPortfolios,
  SearchList,
} from '..'

export function SimpleEntryComponent({ component }) {
  const [reactComponent, setReactComponent] = useState(null)

  const componentsMap = {
    InvestorLogin: InvestorLogin,
    RiaLiterature: RiaLiterature,
    IntervalFundsContainer: IntervalFundsContainer,
    AllProductTypesContainer: AllProductTypesContainer,
    FundLiterature: FundLiterature,
    FormsAndApplications: FormsAndApplications,
    VariableFunds: VariableFunds,
    CombineMorningstarfundsContainer: CombineMorningstarfundsContainer,
    MutualFundsContainer: MutualFundsContainer,
    ExchangeTradedFunds: ExchangeTradedFunds,
    ModelPortfoliosContainer: ModelPortfoliosContainer,
    ClosedEndFundsContainer: ClosedEndFundsContainer,
    IndexDescriptionGlossaryContainer: IndexDescriptionGlossaryContainer,
    FutureScholarPortfolios: FutureScholarPortfolios,
    SearchList: SearchList,
  }

  useEffect(() => {
    setReactComponent(component?.getParameters().reactComponent)
  }, [reactComponent])

  const ReactComponent = componentsMap[reactComponent]

  return ReactComponent ? <ReactComponent /> : null
}

SimpleEntryComponent.propTypes = {
  component: PropTypes.object,
}
